/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceUpdateReqVo
 */
export interface AdditionalServiceUpdateReqVo {
    /**
     * 附加服务名称，必传
     * @type {string}
     * @memberof AdditionalServiceUpdateReqVo
     */
    name: string;
    /**
     * 附加服务名称（中文），必传
     * @type {string}
     * @memberof AdditionalServiceUpdateReqVo
     */
    nameCn: string;
    /**
     * 附加服务编码，必传
     * @type {string}
     * @memberof AdditionalServiceUpdateReqVo
     */
    code: string;
    /**
     * 附加服务价格，必须大于等于 0，必传
     * @type {number}
     * @memberof AdditionalServiceUpdateReqVo
     */
    price: number;
    /**
     * 附加服务组 ID，关联附加服务组表，必传
     * @type {number}
     * @memberof AdditionalServiceUpdateReqVo
     */
    groupId: number;
    /**
     * 附加服务描述，可选
     * @type {string}
     * @memberof AdditionalServiceUpdateReqVo
     */
    description?: string;
    /**
     * 图片 URL 的 JSON 数组，形如 ["","""]，可选
     * @type {Array<string>}
     * @memberof AdditionalServiceUpdateReqVo
     */
    imageUrls?: Array<string>;
    /**
     * 视频 URL 的 JSON 数组，形如 ["","""]，可选
     * @type {Array<string>}
     * @memberof AdditionalServiceUpdateReqVo
     */
    videoUrls?: Array<string>;
    /**
     * 排序，必须大于等于 0，必传
     * @type {number}
     * @memberof AdditionalServiceUpdateReqVo
     */
    sort: number;
    /**
     * 仓库 ID，关联仓库表，必传
     * @type {number}
     * @memberof AdditionalServiceUpdateReqVo
     */
    warehouseId: number;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof AdditionalServiceUpdateReqVo
     */
    enable: number;
    /**
     * 货币代码，如 CNY、USD、KRW 等，必传
     * @type {string}
     * @memberof AdditionalServiceUpdateReqVo
     */
    currencyCode: string;
    /**
     * 是否可以用优惠券 0 不可以， 1 可以
     * @type {number}
     * @memberof AdditionalServiceUpdateReqVo
     */
    canUseCoupon: number;
    /**
     * 下单时是否显示 0 不显示， 1 显示
     * @type {number}
     * @memberof AdditionalServiceUpdateReqVo
     */
    showOnOrder: number;
    /**
     * 附加服务描述 中文
     * @type {string}
     * @memberof AdditionalServiceUpdateReqVo
     */
    descriptionCn?: string;
}

/**
 * Check if a given object implements the AdditionalServiceUpdateReqVo interface.
 */
export function instanceOfAdditionalServiceUpdateReqVo(value: object): value is AdditionalServiceUpdateReqVo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nameCn' in value) || value['nameCn'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('canUseCoupon' in value) || value['canUseCoupon'] === undefined) return false;
    if (!('showOnOrder' in value) || value['showOnOrder'] === undefined) return false;
    return true;
}

export function AdditionalServiceUpdateReqVoFromJSON(json: any): AdditionalServiceUpdateReqVo {
    return AdditionalServiceUpdateReqVoFromJSONTyped(json, false);
}

export function AdditionalServiceUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'nameCn': json['nameCn'],
        'code': json['code'],
        'price': json['price'],
        'groupId': json['groupId'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageUrls': json['imageUrls'] == null ? undefined : json['imageUrls'],
        'videoUrls': json['videoUrls'] == null ? undefined : json['videoUrls'],
        'sort': json['sort'],
        'warehouseId': json['warehouseId'],
        'enable': json['enable'],
        'currencyCode': json['currencyCode'],
        'canUseCoupon': json['canUseCoupon'],
        'showOnOrder': json['showOnOrder'],
        'descriptionCn': json['descriptionCn'] == null ? undefined : json['descriptionCn'],
    };
}

export function AdditionalServiceUpdateReqVoToJSON(json: any): AdditionalServiceUpdateReqVo {
    return AdditionalServiceUpdateReqVoToJSONTyped(json, false);
}

export function AdditionalServiceUpdateReqVoToJSONTyped(value?: AdditionalServiceUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'nameCn': value['nameCn'],
        'code': value['code'],
        'price': value['price'],
        'groupId': value['groupId'],
        'description': value['description'],
        'imageUrls': value['imageUrls'],
        'videoUrls': value['videoUrls'],
        'sort': value['sort'],
        'warehouseId': value['warehouseId'],
        'enable': value['enable'],
        'currencyCode': value['currencyCode'],
        'canUseCoupon': value['canUseCoupon'],
        'showOnOrder': value['showOnOrder'],
        'descriptionCn': value['descriptionCn'],
    };
}

